import React from 'react';

const SwitchArrow: React.FC<React.PropsWithChildren> = () => (
  <path d="M16.05 12.05L21 17L16.05 21.95L14.636 20.536L17.172 17.999L4 18V16H17.172L14.636 13.464L16.05 12.05ZM7.95 2.05L9.364 3.464L6.828 6H20V8H6.828L9.364 10.536L7.95 11.95L3 7L7.95 2.05Z" />
);

export default SwitchArrow;
